import { ReadRecordIfc } from './ReadRecordIfc';
import { RecShapeIfc } from '../shape/RecShapeIfc';

export class ReadRecord implements ReadRecordIfc{
    recShape:RecShapeIfc;
    id:number;
    
    constructor( recShape:RecShapeIfc, id:number ){
        this.recShape = recShape;
        this.id = id;
    }
        
    public getId():number {
        return this.id;
    }
    
    public getRecShape():RecShapeIfc {
        return this.recShape;
    }

    public getIntAt(position:number):number{
        return this.recShape.getIntAt( this.id, position );
    }
    public getNumberAt(position:number):number{
        return this.recShape.getNumberAt( this.id, position );
    }
    
    public getBooleanAt(position:number):boolean{
        return this.recShape.getBooleanAt( this.id, position );
    }
    
    public getStringAt(position:number):string { 
        return this.recShape.getStringAt( this.id, position );
    }
    
    public getIntByName(name:string):number { 
        return this.recShape.getIntByName( this.id, name );
    }
    
    public getNumberByName(name:string):number { 
        return this.recShape.getNumberByName( this.id, name );
    }
    
    public getBooleanByName(name:string):boolean { 
        return this.recShape.getBooleanByName( this.id, name );
    }
    
    public getStringByName(name:string):string{
        return this.recShape.getStringByName( this.id, name );
    }
}